import {
    SPORT_ADD,
    SPORT_UPDATE,
    SPORT_DELETE,
    SET_PAYOUT,
} from "../actionTypes";

const initialState = {
    point: null,
    payout: null,
    eventId: -1,
    sportCategory: null,
    team1Idx: -1,
    eventDate: null,
    playList: [],
    primaryColor: "#0d6efd",
    secondaryColor: "white",
    isFree: false,
};

const sportReducer = (state = initialState, action) => {
    switch (action.type) {
        case SPORT_ADD:
            return { ...state, ...action.payload };
        case SET_PAYOUT:
            return { ...state, ...action.payload };
        case SPORT_UPDATE:
            return { ...state, ...action.payload };
        case SPORT_DELETE:
            return {
                ...state,
                user: null,
                eventId: null,
                sportCategory: null,
                team1Id: null,
                eventDate: null,
                playList: [],
                primaryColor: "#0d6efd",
                secondaryColor: "white",
            };

        default:
            return state;
    }
};

export default sportReducer;
